import Vue           from 'vue'
import BootstrapVue  from 'bootstrap-vue'
import VueRouter     from 'vue-router'
import VueResource   from 'vue-resource'
import VueNativeSock from 'vue-native-websocket'
import VueMq         from 'vue-mq'
import VueApexCharts from 'vue-apexcharts'

import VueMoment     from 'vue-moment'
import moment_tz     from 'moment-timezone'

///

// TODO extend upstream library to support seconds:
//      https://github.com/mariomka/vue-datetime/issues/103
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)

Vue.config.productionTip = false

///

import config   from './config'

import Overview  from './Overview.vue'
import Ledgers   from './Ledgers.vue'
import Txs       from './Txs.vue'
import Accounts  from './Accounts.vue'
import Reports   from './Reports.vue'
import About     from './About.vue'
import API       from './API.vue'
import Gateways  from './Gateways.vue'
import Tags      from './Tags.vue'
import Source    from './Source.vue'
import Waterfall from './Waterfall.vue'

import("../public/common.css")

import './filters.js';

///

Vue.use(VueResource)
Vue.use(VueNativeSock, config.RIPPLE_WS,
                       { format: 'json',
                           store: store,
                     reconnection: true,
               reconnectionDelay : config.RETRY_SECONDS * 1000});

///

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

///

import XRPWaterfall from 'vue-xrp-waterfall'
import 'vue-xrp-waterfall/dist/vue-xrp-waterfall.css'

Vue.use(XRPWaterfall)

///

// Use same sm/md breakpoints as bootstrap:
//   https://getbootstrap.com/docs/4.0/layout/overview/
Vue.use(VueMq, {breakpoints : {sm : 768, md : 992, lg : Infinity}});

Vue.use(VueMoment, {moment_tz});

///

// https://stackoverflow.com/questions/36170425/detect-click-outside-element
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

///

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

///

Vue.use(VueRouter)

const routes = [
  { path: '/',                     component: Overview               },
  { path: '/overview',             component: Overview               },
  { path: '/ledgers',              component: Ledgers                },
  { path: '/ledger/:iledger_id',   component: Ledgers,  props : true },
  { path: '/tx/:itx_id',           component: Txs,      props : true },
  { path: '/gateways',             component: Gateways, props : true },
  { path: '/tags',                 component: Tags,     props : true },
  { path: '/accounts',             component: Accounts               },

  { path: '/accounts/:ipage',      component: Accounts,
    props: function(route) {
      return {ipage : parseInt(route.params.ipage) };
    } },

  { path: '/account/:iid/:isection?', component: Accounts, props: true },

  { path: '/reports/:isection?', component: Reports, props: true },

  { path: '/reports/:iperiod/:isection?', component: Reports,
    props: function(route) {
      switch(route.params.iperiod){
        case '5min'  :
          route.params.iperiod = "300";
          break;
        case 'hour'  :
          route.params.iperiod = "3600";
          break;
        case 'day'   :
          route.params.iperiod = "86400";
          break;
        default :
          route.params.iperiod = "3600";
      }

      return route.params;
    } },

  { path: '/report/:iperiod/:its/:isection?',
    component: Reports, props : true },

  { path: '/about',                component: About                  },
  { path: '/api',                  component: API                    },

  { path: '/source',               component: Source                 },
  { path: '/source/:isection',     component: Source, props: true    },

  { path: '/waterfall',            component: Waterfall              }
]

const router = new VueRouter({
  mode : "history",
  routes : routes
})

///

import { store } from './store'

new Vue({
  router : router,
  store  : store
}).$mount('#app')
